const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Mobile/MobileSFP');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class MobileSFP extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Header")}
					height="226"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="30,31,30,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Header}>
					<ImageView
						id={this.id("Group_5")}
						height="33"
						width="match_parent"
						margin="10,0,10,0"
						imageUrl="group565"
						style={this.style_Group_5} />
					<TextView
						id={this.id("Register")}
						height="25"
						width="match_parent"
						margin="0,44,0,0"
						text={this.STR.Register1}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Register} />
					<TextView
						id={this.id("Forum")}
						height="25"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Forum2}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Forum} />
				</LinearLayout>
				<LinearLayout
					id={this.id("Group_4")}
					height="1985"
					width="300"
					orientation="vertical"
					margin="0,20,0,0"
					cornerRadius="0"
					style={this.style_Group_4}>
					<TextView
						id={this.id("School_of_Functional")}
						height="120"
						width="match_parent"
						text={this.STR.School_of_Functional14}
						textSize={FontSize.A_32}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="40px"
						gravity="left"
						style={this.style_School_of_Functional} />
					<ImageView
						id={this.id("Group_3_Copy")}
						height="317"
						width="252"
						margin="0,50,0,0"
						imageUrl="group3copy67"
						style={this.style_Group_3_Copy} />
					<TextView
						id={this.id("We_d_like_to_see_stu")}
						height="210"
						width="match_parent"
						margin="0,50,0,0"
						text={this.STR.We_d_like_to_see_stu15}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_We_d_like_to_see_stu} />
					<LinearLayout
						id={this.id("Course")}
						height="153"
						width="match_parent"
						orientation="vertical"
						margin="0,30,0,0"
						cornerRadius="0"
						style={this.style_Course}>
						<LinearLayout
							id={this.id("Line_2")}
							height="2"
							width="match_parent"
							background={Color.A__FFD7D7D7}
							stroke="4,#ff0000"
							cornerRadius="0"
							style={this.style_Line_2} />
						<TextView
							id={this.id("Course100000000ø")}
							height="50"
							width="171"
							margin="0,40,0,0"
							text={this.STR.Course16}
							textSize={FontSize.A_40}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_BLACK}
							lineHeight="42px"
							gravity="left"
							style={this.style_Course100000000ø} />
						<LinearLayout
							id={this.id("Takethecours")}
							height="31"
							width="220"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_Takethecours}>
							<ImageView
								id={this.id("Group_7")}
								height="31"
								width="30"
								imageUrl="group768"
								style={this.style_Group_7} />
							<TextView
								id={this.id("Take_the_course")}
								height="30"
								width="180"
								margin="10,1,0,0"
								weight="1"
								text={this.STR.Take_the_course17}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Take_the_course} />
						</LinearLayout>
					</LinearLayout>
					<TextView
						id={this.id("The_course_provides")}
						height="90"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.The_course_provides18}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_The_course_provides} />
					<TextView
						id={this.id("Basics_of_Functional")}
						height="90"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Basics_of_Functional19}
						textSize={FontSize.A_30}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						lineHeight="42px"
						gravity="left"
						style={this.style_Basics_of_Functional} />
					<TextView
						id={this.id("A_simplified_path_to")}
						height="120"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.A_simplified_path_to20}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_A_simplified_path_to} />
					<TextView
						id={this.id("Presto_")}
						height="50"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Presto_21}
						textSize={FontSize.A_30}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						lineHeight="42px"
						gravity="left"
						style={this.style_Presto_} />
					<TextView
						id={this.id("Presto_is_an_app_dev")}
						height="210"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Presto_is_an_app_dev22}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Presto_is_an_app_dev} />
					<TextView
						id={this.id("Discover_Presto")}
						height="30"
						width="165"
						margin="0,10,0,0"
						text="What is Presto?"
						textSize={FontSize.A_22}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_HEAVY}
						gravity="left"
						style={this.style_Discover_Presto} />
					<LinearLayout
						id={this.id("Internship")}
						height="142"
						width="match_parent"
						orientation="vertical"
						margin="0,50,0,0"
						cornerRadius="0"
						style={this.style_Internship}>
						<LinearLayout
							id={this.id("Line_2200000000ø")}
							height="2"
							width="match_parent"
							background={Color.A__FFD7D7D7}
							stroke="4,#ff0000"
							cornerRadius="0"
							style={this.style_Line_2200000000ø} />
						<TextView
							id={this.id("Internship300000000ø")}
							height="50"
							width="230"
							margin="0,30,0,0"
							text={this.STR.Internship24}
							textSize={FontSize.A_40}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_BLACK}
							lineHeight="42px"
							gravity="left"
							style={this.style_Internship300000000ø} />
						<LinearLayout
							id={this.id("KnowmoreGroup10")}
							height="30"
							width="190"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_KnowmoreGroup10}>
							<ImageView
								id={this.id("Group_10")}
								height="30"
								width="30"
								imageUrl="group1069"
								style={this.style_Group_10} />
							<TextView
								id={this.id("Know_more")}
								height="30"
								width="150"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.Know_more25}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Know_more} />
						</LinearLayout>
					</LinearLayout>
					<TextView
						id={this.id("Learn_the_basics_of")}
						height="60"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Learn_the_basics_of26}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Learn_the_basics_of} />
					<TextView
						id={this.id("Learn_Presto")}
						height="30"
						width="match_parent"
						margin="0,13,0,0"
						text={this.STR.Learn_Presto27}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Learn_Presto} />
					<TextView
						id={this.id("Apply_for_an_interns")}
						height="30"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Apply_for_an_interns28}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Apply_for_an_interns} />
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = MobileSFP;



// WEBPACK FOOTER //
// ./views/Mobile/MobileSFP.js